<div
  [cdkMenuTriggerFor]="menu"
  [cdkMenuPosition]="[
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top'
    }
  ]"
  #menuTrigger="cdkMenuTriggerFor"
  (mouseenter)="mouseEnter(menuTrigger)"
  (mouseleave)="mouseLeave(menuTrigger)">
  <ng-content select="trigger"></ng-content>
</div>
<ng-template #menu>
  @let item = navItem();
  <div
    animate.enter="enter-animation"
    animate.leave="leave-animation"
    (mouseenter)="mouseEnter(menuTrigger)"
    (mouseleave)="mouseLeave(menuTrigger)"
    cdkMenu
    class="nav-hover-menu"
    [attr.data-theme]="isDarkMode() ? 'dark' : 'light'">
    @if (!!item.children?.length) {
      @for (childItem of item.children; track childItem.id) {
        <a
          cdkMenuItem
          class="nav-menu-item"
          [routerLink]="childItem.route"
          routerLinkActive="is-active">
          {{ childItem.label | translate }}
        </a>
      }
    } @else {
      <a
        cdkMenuItem
        class="nav-menu-item single"
        [routerLink]="item.route">
        {{ item.label | translate }}
      </a>
    }
  </div>
</ng-template>
